import { ResponsiveBar } from '@nivo/bar'

function BarChartGetCountAssisititiMedici(props) {
    const MyResponsiveBar = ({ data /* see data tab */ }) => (

        <ResponsiveBar
            {...props.commonProperties}
            data={data === null ? [] : data}
            keys={[
                'conteggio',
            ]}
            indexBy="tipo"
            margin={{ top: 50, right: 10, bottom: 50, left: 180 }}
            padding={0.3}
            layout="horizontal"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={{ scheme: 'nivo' }}
            
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: -40
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            // legends={[
            //     {
            //         dataFrom: 'keys',
            //         anchor: 'bottom-right',
            //         direction: 'row',
            //         justify: false,
            //         translateX: 0,
            //         translateY: 50,
            //         itemsSpacing: 2,
            //         itemWidth: 100,
            //         itemHeight: 20,
            //         itemDirection: 'left-to-right',
            //         itemOpacity: 0.85,
            //         symbolSize: 20,
            //         effects: [
            //             {
            //                 on: 'hover',
            //                 style: {
            //                     itemOpacity: 1
            //                 }
            //             }
            //         ]
            //     }
            //]}
            role="application"
            ariaLabel="Nivo bar chart demo"
            barAriaLabel={function (e) { return e.id + ": " + e.formattedValue + " in country: " + e.indexValue }}
        />
    )

    return (
        <>

            <div style={{ height: 350, width: 300 }}>
                <MyResponsiveBar data={props.data} commonProperties={props.commonProperties} />
            </div>
        </>
    );
};

export { BarChartGetCountAssisititiMedici };







